import { createBrowserRouter } from "react-router-dom";
import Layout from "../pages/Layout/Layout";
import Dashboard from "../pages/Dashboard/Dashboard";
import Clients from "../pages/Clients/Clients";
import SubscriptionsAndAddons from "../pages/SubscriptionsAndAddons/SubscriptionsAndAddons";
import Login from "../pages/Auth/Login/Login";
import Auth from "../pages/Auth/Auth";
import AuthProvider from "../providers/AuthProvider/AuthProvider";
import ForgotPassword from "../pages/Auth/ForgotPassword/ForgotPassword";
import SuccessPage from "../pages/SuccessPage/SuccessPage";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import Staff from "../pages/Staff/Staff";
import Admins from "../pages/Staff/Admins/Admins";
import Supports from "../pages/Staff/Supports/Supports";
import SettingsLayout from "../pages/SettingsLayout/SettingsLayout";
import PaymentSettings from "../pages/SettingsLayout/PaymentSettings/PaymentSettings";
import GeneralSettings from "../pages/SettingsLayout/GeneralSettings/GeneralSettings";
import ClientInfo from "../pages/Clients/ClientLayout/ClientInfo/ClientInfo";
import ClientSubscriptionsHistory from "../pages/Clients/ClientLayout/ClientSubscriptionsHistory/ClientSubscriptionsHistory";
import ReferralProgram from "../pages/ReferralProgram/ReferralProgram";
import GymListings from "../pages/GymListings/GymListings";
import GymListingsPreview from "../pages/GymListings/Preview/Preview";
import MapProvider from "../providers/MapProvider/MapProvider";
import LoyaltyPoints from "../pages/LoyaltyPoints/LoyaltyPoints";
import PurchaseHistory from "../pages/PurchaseHistory/PurchaseHistory";
import Contracts from "../pages/Contracts/Contracts";
import Reviews from "../pages/Reviews/Reviews";
import Classes from "../pages/GymListings/Classes/Classes";
import ClassesCategories from "../pages/ClassesCategories/ClassesCategories";
import GymsAndGroupClasses from "../pages/GymsAndGroupClasses/GymsAndGroupClasses";
import OpenGyms from "../pages/GymsAndGroupClasses/OpenGyms/OpenGyms";
import GroupClasses from "../pages/GymsAndGroupClasses/GroupClasses/GroupClasses";
import GymNotifications from "../pages/GymNotifications/GymNotifications";
import ClientLayout from "../pages/Clients/ClientLayout/ClientLayout";
import ClientGymNotification from "../pages/Clients/ClientLayout/ClientGymNotification/ClientGymNotification";
import ClientReservations from "../pages/Clients/ClientLayout/ClientReservations/ClientReservations";
import ClientOpenGyms from "../pages/Clients/ClientLayout/ClientOpenGyms/ClientOpenGyms";
import MaintenanceSettings from "../pages/SettingsLayout/MaintenanceSettings/MaintenanceSettings";
import AutomatedEmails from "../pages/AutomatedEmails/AutomatedEmails";
import CreateAutomatedEmail from "../pages/AutomatedEmails/CreateAutomatedEmail/CreateAutomatedEmail";
import LastMinuteDeals from "../pages/LastMinuteDeals/LastMinuteDeals";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <Layout />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: "clients", element: <Clients /> },
      {
        path: "clients/:id",
        element: <ClientLayout />,
        children: [
          { path: "details", element: <ClientInfo /> },
          { path: "reservations", element: <ClientReservations /> },
          { path: "open-gyms", element: <ClientOpenGyms /> },
          { path: "gym-notifications", element: <ClientGymNotification /> },
          { path: "subscription-history", element: <ClientSubscriptionsHistory /> },
        ],
      },
      { path: "gym-listings", element: <GymListings /> },
      {
        path: "gym-listings/preview/:id",
        element: (
          <MapProvider>
            <GymListingsPreview />
          </MapProvider>
        ),
      },
      {
        path: "gym-listings/classes/:id",
        element: <Classes />,
      },
      { path: "subscriptions", element: <SubscriptionsAndAddons /> },
      {
        path: "staff",
        element: <Staff />,
        children: [
          { path: "admins", element: <Admins /> },
          { path: "supports", element: <Supports /> },
        ],
      },
      { path: "referral-program", element: <ReferralProgram /> },
      { path: "loyalty-points", element: <LoyaltyPoints /> },
      {
        path: "settings",
        element: <SettingsLayout />,
        children: [
          { path: "general", element: <GeneralSettings /> },
          { path: "maintenance", element: <MaintenanceSettings /> },
          { path: "payment", element: <PaymentSettings /> },
        ],
      },
      { path: "purchase-history", element: <PurchaseHistory /> },
      { path: "contracts", element: <Contracts /> },
      { path: "reviews", element: <Reviews /> },
      { path: "classes-categories", element: <ClassesCategories /> },
      {
        path: "gyms-and-group-classes",
        element: <GymsAndGroupClasses />,
        children: [
          { path: "open-gyms", element: <OpenGyms /> },
          { path: "group-classes", element: <GroupClasses /> },
        ],
      },
      { path: "gym-notifications", element: <GymNotifications /> },
      { path: "automated-emails", element: <AutomatedEmails /> },
      { path: "automated-emails/:id", element: <CreateAutomatedEmail /> },
      { path: "last-minute-deals", element: <LastMinuteDeals /> },
    ],
  },
  {
    path: "/auth",
    element: <Auth />,
    children: [
      { path: "login", element: <Login /> },
      { path: "forgot-password", element: <ForgotPassword /> },
    ],
  },
  { path: "success", element: <SuccessPage /> },
  { path: "/*", element: <ErrorPage /> },
]);

export default router;
